import FKGroteskNeueBoldWoff from '../fonts/FKGroteskNeue-Bold-v1.1.6.woff';
import FKGroteskNeueBoldWoff2 from '../fonts/FKGroteskNeue-Bold-v1.1.6.woff2';
import FKGroteskNeueBoldItalicWoff from '../fonts/FKGroteskNeue-BoldItalic-v1.1.6.woff';
import FKGroteskNeueBoldItalicWoff2 from '../fonts/FKGroteskNeue-BoldItalic-v1.1.6.woff2';
import FKGroteskNeueItalicWoff from '../fonts/FKGroteskNeue-Italic-v1.1.6.woff';
import FKGroteskNeueItalicWoff2 from '../fonts/FKGroteskNeue-Italic-v1.1.6.woff2';
import FKGroteskNeueMediumWoff from '../fonts/FKGroteskNeue-Medium-v1.1.6.woff';
import FKGroteskNeueMediumWoff2 from '../fonts/FKGroteskNeue-Medium-v1.1.6.woff2';
import FKGroteskNeueMediumItalicWoff from '../fonts/FKGroteskNeue-MediumItalic-v1.1.6.woff';
import FKGroteskNeueMediumItalicWoff2 from '../fonts/FKGroteskNeue-MediumItalic-v1.1.6.woff2';
import FKGroteskNeueRegularWoff from '../fonts/FKGroteskNeue-Regular-v1.1.6.woff';
import FKGroteskNeueRegularWoff2 from '../fonts/FKGroteskNeue-Regular-v1.1.6.woff2';

export const fontFamily = 'FK Grotesk Neue';
export const baseFontFamily: string = [
  'FK Grotesk Neue',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

export const fontFace = `
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url(${FKGroteskNeueRegularWoff2}) format('woff2'), url(${FKGroteskNeueRegularWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 400;
    font-style: italic;
    font-display: block;
    src: url(${FKGroteskNeueItalicWoff2}) format('woff2'), url(${FKGroteskNeueItalicWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url(${FKGroteskNeueMediumWoff2}) format('woff2'), url(${FKGroteskNeueMediumWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 500;
    font-style: italic;
    font-display: block;
    src: url(${FKGroteskNeueMediumItalicWoff2}) format('woff2'), url(${FKGroteskNeueMediumItalicWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 600;
    font-style: normal;
    font-display: block;
    src: url(${FKGroteskNeueMediumWoff2}) format('woff2'), url(${FKGroteskNeueMediumWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 600;
    font-style: italic;
    font-display: block;
    src: url(${FKGroteskNeueMediumItalicWoff2}) format('woff2'), url(${FKGroteskNeueMediumItalicWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url(${FKGroteskNeueBoldWoff2}) format('woff2'), url(${FKGroteskNeueBoldWoff}) format('woff')
  }
  @font-face {
    font-family: 'FK Grotesk Neue';
    font-weight: 700;
    font-style: italic;
    font-display: block;
    src: url(${FKGroteskNeueBoldItalicWoff2}) format('woff2'), url(${FKGroteskNeueBoldItalicWoff}) format('woff')
  }
  `;
